import { Box, useTheme } from "@mui/material";
import type { FC } from "react";
import type { NotificationCenterTab } from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import { useNotificationCenterTabs } from "web_myplann/NotificationCenter/Hooks/useNotificationCenterTabs";
import { MyPlannTabsRedesign } from "web_myplann/Shared/Components/Redesign/MyPlannTabsRedesign";

type Props = {
	activeTab: NotificationCenterTab;
	onTabChange: (tab: NotificationCenterTab) => void;
};

export const NotificationCenterTabSwitch: FC<Props> = ({
	activeTab,
	onTabChange,
}) => {
	const { palette, spacingTokens } = useTheme();
	const { tabs, value, onChange } = useNotificationCenterTabs(
		activeTab,
		onTabChange,
	);

	return (
		<Box
			pt={spacingTokens.sm}
			px={spacingTokens.lg}
			pb={spacingTokens.md}
			bgcolor={palette.background.paper}
		>
			<MyPlannTabsRedesign value={value} onChange={onChange} tabs={tabs} />
		</Box>
	);
};
